var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nothingness-activity-wrapper"},[_c('NoWorksData',{attrs:{"noDataText":"活动不存在"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }